<template>
  <div class="addPerson__wrap" v-if="visible" style="z-index: 9999 !important">
    <el-header class="page-header__wrap">
      <div class="title">
        {{ $route.matched[0].meta.title }}
        <span v-if="$route.matched[0].meta.title"> > </span>
        {{ $route.meta.title }}
        <span>></span>
        预览文件
      </div>

      <div style="display: flex; align-items: center">
        <el-button
          type="danger"
          plian
          size="mini"
          plain
          @click="toggle(false)"
          icon="el-icon-close"
          >关闭</el-button
        >
      </div>
    </el-header>

    <div class="page-main__wrap">
      <div style="flex: 1; margin: 20px; display: flex">
        <vue-office-excel
          v-show="fileType == 5"
          :src="fileUrl"
          :options="options"
          style="width: 100%; height: 100%"
          @rendered="renderedHandler"
          @error="errorHandler"
        />
      </div>
    </div>
  </div>
</template>
<script>
//引入VueOfficeExcel组件
import VueOfficeExcel from "@vue-office/excel";
//引入相关样式
import "@vue-office/excel/lib/index.css";
export default {
  name: "fileView",
  components: {
    VueOfficeExcel,
  },
  props: {
    fileUrl: { required: false, type: String, default: "" }, //设置文档地址
    fileType: { required: false, type: Number, default: 0 },
    fileName: { required: false, type: String, default: "" },

    // excel: 'http://static.shanhuxueyuan.com/demo/excel.xlsx'//设置文档地址
  },
  data() {
    return {
      visible: false,
      options: {
        xls: true, //预览xlsx文件设为false；预览xls文件设为true
        minColLength: 0, // excel最少渲染多少列，如果想实现xlsx文件内容有几列，就渲染几列，可以将此值设置为0.
        minRowLength: 0, // excel最少渲染多少行，如果想实现根据xlsx实际函数渲染，可以将此值设置为0.
        widthOffset: 30, //如果渲染出来的结果感觉单元格宽度不够，可以在默认渲染的列表宽度上再加 Npx宽
        heightOffset: 10, //在默认渲染的列表高度上再加 Npx高
        beforeTransformData: (workbookData) => {
          return workbookData;
        }, //底层通过exceljs获取excel文件内容，通过该钩子函数，可以对获取的excel文件内容进行修改，比如某个单元格的数据显示不正确，可以在此自行修改每个单元格的value值。
        transformData: (workbookData) => {
          return workbookData;
        }, //将获取到的excel数据进行处理之后且渲染到页面之前，可通过transformData对即将渲染的数据及样式进行修改，此时每个单元格的text值就是即将渲染到页面上的内容
      },
    };
  },

  methods: {
    getDetail(row) {
      this.options.xls =
        row.name.substr(row.name.lastIndexOf(".")) == ".xlsx" ? false : true;
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    renderedHandler() {
      console.log("渲染完成");
    },
    errorHandler() {
      console.log("渲染失败");
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/scss/index.scss";
.addPerson__wrap {
  // @include position($t: 0, $r: 0, $b: 0, $l: 0);
  background-color: #f2f5fc;
  z-index: 5 !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: fixed !important;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.page-header__wrap {
  height: 50px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #595959;
}
.page-main__wrap {
  background: #fff;
  margin: 20px;
  border-radius: 10px;
  margin-top: 0 !important;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.officeDocx {
  height: calc(100vh - 100px);
}

.pp {
  font-size: 12px;
  color: #646b75;
  margin: 0 30px 0 0;
  cursor: pointer;
  font-weight: 500;
}
.pimg {
  width: 16px;
  height: 16px;
  margin: 0 5px 0 0;
}

@media print {
  body * {
    visibility: visible !important;
  }
  #print-area {
    width: 100% !important;
    margin: 0 !important;
  }
  .el-table__body {
    /* 兼容Element UI等框架 */
    color: #000 !important;
  }
  .ofd-item {
    margin: 0 !important;
  }
  #ofd-61 {
    margin: 0 !important;
  }
}
p.docx_46 {
  margin-bottom: 7.8pt;
  text-indent: 0pt;
  text-align: center;
  margin-top: 7.8pt;
}
</style>